
<script>
</script>

<style>
    hr {
        border: none;
        border-bottom: 1px solid var(--accent);
    }
</style>

<div class="divider flex gap-05">

    <hr class="flex-fill">

    <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 15H15L10.5 8.5H13.5L8 1L2.5 8.5H5.5L1 15H8ZM8 15V19" stroke="#AC8039" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 15H15L10.5 8.5H13.5L8 1L2.5 8.5H5.5L1 15H8ZM8 15V19" stroke="#AC8039" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 15H15L10.5 8.5H13.5L8 1L2.5 8.5H5.5L1 15H8ZM8 15V19" stroke="#AC8039" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    <hr class="flex-fill">

</div>
